import PropTypes from "prop-types";
import React from "react";
import {
  ActivityIndicator,
  View,
  TouchableOpacity,
  TouchableWithoutFeedback,
  ScrollView,
} from "react-native";
import * as RootNavigation from "app/utils/RootNavigation.js";
import valueHelpers from "app/utils/valueHelpers";
import textHelpers from "app/utils/textHelpers";
import valueActions from "app/utils/valueActions";
import colorHelpers from "app/utils/colorHelpers";

import Text from "app/components/Text";
import RichText from "app/components/RichText";
import TextInput from "app/components/TextInput";
import Autocomplete from "app/components/Autocomplete";
import MultiButton from "app/components/MultiButton";
import Hoverable from "app/components/Hoverable";
import Badge from "app/components/chapter/Badge";

import { StyleContext } from "app/contexts/Style";

export default class ColorWheel extends React.Component {
  static contextType = StyleContext;
  constructor(props, context) {
    super(props, context);
    let colors = valueHelpers.colorOptions();
    let R = 300;
    let C = 2 * Math.PI * R;
    this.state = {
      // color: valueHelpers.getColor(props.value, context.colorScheme),
      colors,
      C,
      R,
    };
  }

  componentDidMount = async () => {
    // this.setSuggestions();
  };

  render() {
    let { C, R } = this.state;
    return (
      <View style={[this.styles().wrapper, { width: R * 2, height: R * 2 }]}>
        {this.renderWheel("colors")}
        <View style={this.styles().hub} />
        {this.renderWheel("values")}
      </View>
    );
  }

  renderWheel = (type) => {
    let { values, rootIds } = this.props;
    let { colors, C, R } = this.state;
    let { hoveredWedgeIndex, hoveredValueId } = this.state;

    colors = colors.filter((c) => !!values.find((v) => v.color == c));
    let sliceDeg = 360 / colors.length;
    // colors = colors.slice(0, 4);

    return (
      <View
        style={[this.styles().wheelWrapper, { width: R * 2, height: R * 2 }]}
      >
        {colors.map((c, i) => {
          let rot = sliceDeg * i;
          let bgColor =
            type == "colors"
              ? valueHelpers.colorAsHex(c, this.context.colorScheme)
              : null;
          return (
            <View
              key={i}
              style={[
                this.styles().wedge,
                {
                  zIndex:
                    type == "values" && hoveredWedgeIndex == i
                      ? 99
                      : colors.length - i,
                  backgroundColor: !!bgColor
                    ? colorHelpers.hexToRgbaString(bgColor, 0.2)
                    : null,
                  borderColor: bgColor,
                  borderTopWidth: !!bgColor ? 15 : 0,
                  width: C / colors.length,
                  transform: [
                    { translateX: `-50%` },
                    { translateY: `50%` },
                    { rotateZ: `${rot}deg` },
                    { translateY: `-50%` },
                  ],
                },
              ]}
            >
              {type == "values" && (
                <View style={this.styles().wedgeCol}>
                  <View style={this.styles().innerWedgeCol}>
                    {values
                      .filter((v) => v.color == c)
                      .sort((a, b) => {
                        if (rootIds.includes(a.id)) return -1;
                        else return 1;
                      })
                      .map((value, j) => {
                        return (
                          <View
                            key={j}
                            style={[
                              { transform: [{ rotateZ: `${rot * -1}deg` }] },
                              { zIndex: hoveredValueId == value.id ? 99 : 1 },
                              // { flex: 1 },
                            ]}
                          >
                            <Badge
                              onPress={(e) =>
                                RootNavigation.push(
                                  "Value",
                                  { id: value.id },
                                  e,
                                )
                              }
                              moment={{
                                value: {
                                  ...value,
                                  completed_at: null,
                                  percent: 0,
                                },
                              }}
                              iconColor={valueHelpers.colorAsHex(
                                c,
                                this.context.colorScheme,
                              )}
                              // giant={!value.parent_ids?.length}
                              giant={rootIds.includes(value.id)}
                              onHoverIn={() =>
                                this.setState({
                                  hoveredWedgeIndex: i,
                                  hoveredValueId: value.id,
                                })
                              }
                              onHoverOut={() =>
                                this.setState({
                                  hoveredWedgeIndex: null,
                                  hoveredValueId: null,
                                })
                              }
                            />
                          </View>
                        );
                      })}
                  </View>
                </View>
              )}
            </View>
          );
        })}
      </View>
    );
  };

  styles = () => {
    return {
      wrapper: {
        // padding: this.context.sizes.large,
        // borderWidth: 2,
        borderColor: "green",
      },
      wheelWrapper: {
        position: "absolute",
      },
      wedge: {
        position: "absolute",
        top: 0,
        left: "50%",
        // width: "10%",
        height: "50%",
        // borderWidth: 1,
        // borderTopWidth: 10,
        borderRadius: 999,
        paddingTop: 30,
        // borderTopLeftRadius: 999,
        // borderTopRightRadius: 999,
        // borderBottomLeftRadius: 999,
        // borderBottomRightRadius: 999,
      },
      wedgeCol: {
        // borderWidth: 1,
        flexDirection: "row",
        // alignSelf: "stretch",
        alignItems: "flex-start",
        justifyContent: "center",
        height: "90%",
        // flexWrap: "wrap",
      },
      innerWedgeCol: {
        flex: 1,
        justifyContent: "flex-start",
        alignItems: "center",
        flexWrap: "wrap",
        borderColor: "red",
        // borderWidth: 2,
        maxHeight: "100%",
      },
      hub: {
        position: "absolute",
        width: "25%",
        height: "25%",
        top: "37.5%",
        left: "37.5%",
        width: "30%",
        height: "30%",
        top: "35%",
        left: "35%",
        borderRadius: 999,
        backgroundColor: this.context.colors.empty,
      },
    };
  };
}
